import '../style/projects.sass'
import '../style/spinner.sass'
import '../style/index.sass'

import { useEffect, useState } from "react"
import sanityClient from "../client.js"
import { Link } from 'react-router-dom'

const bg = require('../assets/dji/DJI_0010.JPG')

export default function Project() {
    const [projectData, setProjectData] = useState(null)

    useEffect(() => {
        sanityClient
            .fetch(`*[_type == "project"]{
                title,
                date,
                place,
                description,
                projectType,
                linkTo,
                linkReport,
                slug,
                mainImage{
                    asset->{
                        _id,
                        url
                    },
                    alt
                },
                tags
            }`)
            .then((data) => { setProjectData(data) })
            .catch(console.error)
    }, [])

    return (
        <section id="projects">
            {!projectData && <div className="spinner"></div>}
            <div className="smallProject">
                {projectData && projectData.map((project, index) => (
                    <article>
                        <div className='title'>
                            <h3>
                                <Link to={'/projects/' + project.slug.current} key={project.slug.current}>
                                    {project.title}
                                </Link>
                            </h3>
                        </div>

                        <div className='info'>
                            <p>{project.date ? <><strong>Completed |</strong> {new Date(project.date).toLocaleDateString()}</> : 'Not completed'}</p>
                            <p><strong>Location | </strong> {project.place}</p>
                            <p><strong>This was a </strong>{project.projectType} project </p>
                        </div>
                        {/* <div className='mainImage'>
                            <img src={project.mainImage.asset.url} alt={project.mainImage.alt} />
                        </div> */}

                        <div className='desc'>
                            <p>{project.description}</p>
                        </div>
                        {project.tags &&
                            <div className="tags">
                                {project.tags.map(tag => (
                                    <p>{tag}</p>
                                ))}
                            </div>}
                        <div className='linkTo'>
                            {project.linkTo ? (
                                <a href={project.linkTo} alt={project.title} target="_blank" rel="noopener noreferrer">
                                    View the project website
                                </a>
                            ) : (
                                <p>Project is not hosted as of this moment</p>
                            )}
                        </div>
                    </article>
                ))}
            </div>
        </section>
    )
}